import type { BiasEntry } from './biases';

export const biases: BiasEntry[] = [
  {
    id: 1,
    slug: 'availability-heuristics',
    name: 'Эвристика доступности',
    scenario:
      'Страница загрузки приложения для облачного хранилища на блокчейне',
    withoutBias:
      'Лендинг крупно заявляет «На базе блокчейн-технологии» и использует крипто-визуалы (иконки цепей, упоминания токенов)',
    withBias:
      'Тот же продукт описан как «Облачное хранилище с шифрованием военного уровня», без упоминаний блокчейна — функционал идентичен, подача другая',
    whyItWorks:
      'Пользователи помнят негативные ассоциации из медиа с блокчейном и крипто, поэтому избегают всего связанного с ними. Переформулировка той же технологии нейтральным языком обходит негативную эвристику доступности.',
    category: 'Perception',
  },
  {
    id: 2,
    slug: 'attentional-bias',
    name: 'Смещение внимания',
    scenario: 'Дашборд с метриками вовлечённости',
    withoutBias: 'Базовый профиль (заполнен на 75%, дата регистрации)',
    withBias:
      'На первом плане очки кармы, лайки, ранг контрибьютора, стрик активности',
    whyItWorks:
      'Эмоционально заряженные метрики захватывают внимание и подталкивают к созданию контента через стремление к социальному одобрению.',
    category: 'Perception',
  },
  {
    id: 3,
    slug: 'illusory-truth-effect',
    name: 'Эффект иллюзии правды',
    scenario: 'Лендинг с повторяющимся утверждением',
    withoutBias: 'Обычное описание функции',
    withBias:
      '«Инструмент управления проектами №1» повторяется в заголовке, подзаголовке, CTA и отзывах',
    whyItWorks:
      'Повторение создаёт знакомость, которую мозг интерпретирует как истину. Доказательства не нужны.',
    category: 'Memory',
  },
  {
    id: 4,
    slug: 'mere-exposure-effect',
    name: 'Эффект простого предъявления',
    scenario:
      'Страница приложения в сторе, таргетированная на французских пользователей',
    withoutBias:
      'Универсальный международный листинг — стандартная сине-белая палитра, стоковые фото разных пользователей, англоязычная вёрстка',
    withBias:
      'Акценты в цветах триколора (сине-бело-красный), ватермарк парижского пейзажа за героем, отзывы французских пользователей с локальными названиями городов',
    whyItWorks:
      'Знакомые культурные сигналы (цвета, ориентиры, местные имена) запускают подсознательное предпочтение — пользователь не осознаёт, почему страница кажется более надёжной.',
    category: 'Memory',
  },
  {
    id: 5,
    slug: 'context-effect',
    name: 'Эффект контекста',
    scenario: 'Лендинг для сбора пожертвований',
    withoutBias:
      'Коммерческая визуальная подача (CTA «КУПИТЬ СЕЙЧАС», плашка срочности)',
    withBias:
      'Согласованный контекст (природные изображения, CTA «Защитить лес», отзывы сторонников)',
    whyItWorks:
      'Когда визуальная среда соответствует ценностям сообщения, доверие и конверсия растут.',
    category: 'Perception',
  },
  {
    id: 6,
    slug: 'cue-dependent-forgetting',
    name: 'Забывание, зависимое от подсказок',
    scenario: 'Пуш-уведомление фитнес-приложения для вернувшегося пользователя',
    withoutBias:
      '«Вы не тренировались 18 дней. Откройте приложение, чтобы вернуться в форму.»',
    withBias:
      '«Помните свой 14-дневный стрик в октябре? Вы выполнили 42 тренировки за месяц. Готовы ко второму раунду?» с мини-графиком прошлого стрика',
    whyItWorks:
      'Конкретные подсказки из прошлого успеха (длина стрика, месяц, количество тренировок) запускают воспоминания о позитивном опыте, которые обычные сообщения не вызывают.',
    category: 'Memory',
  },
  {
    id: 7,
    slug: 'mood-congruent-memory-bias',
    name: 'Искажение памяти, конгруэнтной настроению',
    scenario:
      'Напоминание SaaS о продлении подписки для пользователя, недавно пережившего сбой сервиса',
    withoutBias:
      'Автоматическое письмо о продлении по расписанию: «Ваш годовой план истекает через 3 дня. Продлите сейчас за $199 в год.»',
    withBias:
      'Система видит недавний тикет о сбое, откладывает письмо о продлении на неделю и начинает с разрешения проблемы: «Мы починили проблему синхронизации, о которой вы сообщили. Всё снова работает стабильно. Кстати, ваш план продлевается на следующей неделе.»',
    whyItWorks:
      'Просьба оплатить во время фрустрации запускает воспоминания о каждом прошлом недовольстве. Ожидание позитивного сдвига настроения гарантирует, что решение о продлении окрасится свежим хорошим опытом.',
    category: 'Memory',
  },
  {
    id: 8,
    slug: 'frequency-illusion',
    name: 'Иллюзия частотности',
    scenario:
      'Главная страница, справочный центр и внутренний баннер платформы для фриланс-платежей',
    withoutBias:
      'На каждой поверхности свой оффер — главная говорит «Простые инвойсы», справка — «Ведите бизнес», приложение — «Дашборд»',
    withBias:
      'Общий слоган «Самые быстрые выплаты для фрилансеров» появляется в герое главной, шапке справочного центра, приветственном баннере приложения и футере писем — везде одна формулировка',
    whyItWorks:
      'Стоит пользователю заметить утверждение о «самых быстрых выплатах» в одном месте — и он начинает замечать его везде. Повторение в независимых контекстах создаёт ощущение общепризнанной истины.',
    category: 'Memory',
  },
  {
    id: 9,
    slug: 'empathy-gap',
    name: 'Разрыв эмпатии',
    scenario: 'Интерфейс чата поддержки, отвечающий разгневанному пользователю',
    withoutBias:
      'Бот отвечает на жалобу: «Пожалуйста, успокойтесь и опишите проблему чётко, чтобы мы могли помочь.»',
    withBias:
      'Бот отвечает: «Понимаем, что это расстраивает. Давайте разберёмся вместе. Расскажите, что произошло?» — эмпатичный тон, без обесценивания эмоции',
    whyItWorks:
      'Сотрудники поддержки в нейтральном состоянии по умолчанию дают рационально-первые ответы, игнорирующие эмоции пользователя. Сначала признать чувство — значит навести мост через разрыв эмпатии и снять напряжение.',
    category: 'Social',
  },
  {
    id: 10,
    slug: 'omission-bias',
    name: 'Смещение бездействия',
    scenario: 'Флоу отмены подписки',
    withoutBias: 'Прямая ссылка «Отменить подписку»',
    withBias:
      'Многошаговая отмена (Аккаунт → Биллинг → Управление планом → Отменить)',
    whyItWorks:
      'Люди судят о вредных действиях строже, чем о столь же вредном бездействии. Трудоёмкая отмена эксплуатирует это.',
    category: 'Decision',
  },
  {
    id: 11,
    slug: 'base-rate-fallacy',
    name: 'Ошибка базовой оценки',
    scenario: 'Страница продукта в сторе с отзывами',
    withoutBias:
      'Все отзывы в хронологическом порядке — 3 свежих негативных отзыва на 1 звезду сверху, затем тысячи положительных; общий «4.8 из 15 847 оценок» указан мелко внизу',
    withBias:
      '«4.8 из 15 847 оценок» крупно сверху с гистограммой распределения звёзд (95% пятизвёздочных), негативные отзывы доступны, но не на первом плане',
    whyItWorks:
      'Пользователи фиксируются на ярких негативных отзывах и игнорируют базовую статистику. Ведение с агрегированных данных навязывает корректную общую картину до того, как любой отдельный случай успеет заякорить восприятие.',
    category: 'Social',
  },
  {
    id: 12,
    slug: 'bizarreness-effect',
    name: 'Эффект причудливости',
    scenario: 'Карточка продукта с отличительным брендингом',
    withoutBias:
      'Стандартная карточка приложения (HabitFlow, Бесплатно, плашка «Продуктивность»)',
    withBias:
      'Причудливый образ («Ваш восьмирукий партнёр по ответственности», иллюстрация осьминога)',
    whyItWorks:
      'Необычный контент оставляет более глубокий след в памяти. Пользователи запоминают странное.',
    category: 'Memory',
  },
  {
    id: 13,
    slug: 'humor-effect',
    name: 'Эффект юмора',
    scenario: 'Страница ошибки 404 для легковесной контент-платформы',
    withoutBias: '«Страница не найдена. Ошибка 404. Вернуться на главную.»',
    withBias:
      '«Эта страница ушла искать себя. Пока её нет, вот статьи, которые остались на месте.» с игривой иллюстрацией и ссылками на контент',
    whyItWorks:
      'Юмористический контент оставляет более сильный след в памяти, чем нейтральный. В низко-стрессовых ситуациях остроумие формирует запоминающуюся личность бренда и превращает тупики во вовлечение.',
    category: 'Memory',
  },
  {
    id: 14,
    slug: 'picture-superiority-effect',
    name: 'Эффект превосходства изображения',
    scenario: 'Список функций — текст против иллюстраций',
    withoutBias:
      'Текстовые описания («Канбан-доски для визуального управления потоком работ…»)',
    withBias:
      'Короткие подписи с SVG-иллюстрациями (канбан-доска, часы, люди, дашборд)',
    whyItWorks:
      'Изображения кодируются через двойной канал (визуальный + вербальный). Удержание в памяти в 6 раз выше, чем у чистого текста.',
    category: 'Memory',
  },
  {
    id: 15,
    slug: 'von-restorff-effect',
    name: 'Эффект фон Ресторфф',
    scenario: 'Навигационное меню с одним выделенным пунктом',
    withoutBias: 'Все пункты навигации выглядят одинаково',
    withBias: '«Тарифы» выделены плашкой «Новое»',
    whyItWorks:
      'Визуально отличающийся элемент захватывает внимание и запоминается значительно лучше.',
    category: 'Perception',
  },
  {
    id: 16,
    slug: 'self-reference-effect',
    name: 'Эффект самореференции',
    scenario: 'Таргетинг лендинга',
    withoutBias: '«Управление проектами для команд любого размера»',
    withBias:
      '«Создано для фрилансеров, жонглирующих 5+ клиентами» с сегментным отзывом',
    whyItWorks:
      'Лично релевантный контент запускает узнавание «это про меня» и кодируется глубже.',
    category: 'Social',
  },
  {
    id: 17,
    slug: 'negativity-bias',
    name: 'Смещение к негативу',
    scenario: 'Уведомление об инциденте',
    withoutBias: '«Инцидент устранён. Uptime: 99,97%»',
    withBias:
      '«Обслуживание завершено. Ваши данные в безопасности. Вот что мы улучшили…» с конкретикой',
    whyItWorks:
      'Одно негативное событие сводит на нет месяцы позитивных. Проактивная коммуникация нейтрализует непропорциональный вес.',
    category: 'Social',
  },
  {
    id: 18,
    slug: 'anchoring-effect',
    name: 'Эффект якорения',
    scenario: 'Таблица тарифов с перечёркнутыми исходными ценами',
    withoutBias: 'Три плана по номиналу ($10, $25, $50 в месяц)',
    withBias:
      'Те же планы с перечёркнутыми «исходными» ценами ($49, $99), из-за чего текущие кажутся значительной скидкой',
    whyItWorks:
      'Первое увиденное число доминирует в оценке стоимости. Произвольный якорь превращает $25 в месяц в ощущение выгодной сделки.',
    category: 'Decision',
  },
  {
    id: 19,
    slug: 'conservatism',
    name: 'Консерватизм',
    scenario:
      'Онбординг инструмента управления проектами для мигрирующих от конкурента',
    withoutBias:
      'Онбординг навязывает новый процесс: «Забудьте всё, что знали! Наш революционный подход Board-First меняет всё. Начните с нуля.»',
    withBias:
      'Онбординг подстраивается под прошлый инструмент: «Переходите из Trello? Мы настроили воркспейс со знакомыми досками и колонками. Попробуйте временную шкалу, когда будете готовы — без спешки.»',
    whyItWorks:
      'Пользователи держатся за прежние представления о том, «как должны» работать процессы. Принудительная смена парадигмы вызывает сопротивление, а уважение ментальных моделей и постепенное введение нового даёт принятие.',
    category: 'Perception',
  },
  {
    id: 20,
    slug: 'contrast-effect',
    name: 'Эффект контраста',
    scenario: 'Карточка продукта между крайностями',
    withoutBias: 'Один средний продукт (наушники за $79)',
    withBias:
      'Тот же продукт между премиум ($349) и бюджетным ($19) вариантами',
    whyItWorks:
      'Окружающий контекст перекраивает восприятие ценности, не меняя продукт.',
    category: 'Decision',
  },
  {
    id: 21,
    slug: 'distinction-bias',
    name: 'Смещение различения',
    scenario: 'Тарифы рядом друг с другом и по отдельности',
    withoutBias: 'Два похожих плана бок о бок (Team $12, Business $14)',
    withBias:
      'Те же планы, между которыми нужно скроллить (представлены раздельно)',
    whyItWorks:
      'Подача бок о бок преувеличивает небольшие различия. Разнесение уменьшает трение при принятии решения.',
    category: 'Decision',
  },
  {
    id: 22,
    slug: 'framing-effect',
    name: 'Эффект формулировки',
    scenario: 'Уведомление об обновлении системы',
    withoutBias: '«Вероятность потери данных — 1%»',
    withBias: '«99% вероятности, что операция завершится успешно»',
    whyItWorks:
      'Идентичная информация — противоположные эмоциональные реакции. Позитивная рамка повышает уверенность.',
    category: 'Decision',
  },
  {
    id: 23,
    slug: 'money-illusion',
    name: 'Денежная иллюзия',
    scenario: 'Тарифы в разных временных единицах',
    withoutBias: 'Годовые цены ($120/год, $300/год, $600/год)',
    withBias:
      'Дневные цены ($0,33/день, $0,82/день «Меньше чашки кофе», $1,64/день)',
    whyItWorks:
      'Люди смотрят на номинал. $0,82 в день кажется пустяком, $300 в год — дорого. При той же общей стоимости.',
    category: 'Decision',
  },
  {
    id: 24,
    slug: 'weber-fechner-law',
    name: 'Закон Вебера — Фехнера',
    scenario: 'Подача скидки',
    withoutBias:
      'Одна и та же абсолютная скидка ($5) на товар за $25 и за $500',
    withBias:
      'Пропорциональная подача (СКИДКА 20% на товар за $25, 1% на товар за $500)',
    whyItWorks:
      'Воспринимаемая значимость пропорциональна базе. Масштабируйте скидки, чтобы сохранить психологический эффект.',
    category: 'Decision',
  },
  {
    id: 25,
    slug: 'confirmation-bias',
    name: 'Предвзятость подтверждения',
    scenario: 'Дашборд безопасности аккаунта для анонимного маркетплейса',
    withoutBias:
      'Обычная страница настроек: «Настройки безопасности» с изменением пароля и переключателем 2FA, без проактивных сигналов доверия',
    withBias:
      'Баннер «Статус безопасности: защищено» с индикаторами в реальном времени (сквозное шифрование активно, 0 утечек, анонимный ID верифицирован), а также ссылкой на «Отчёт о прозрачности» и датой последнего аудита',
    whyItWorks:
      'Скептически настроенные пользователи активно ищут доказательства, что платформа небезопасна. Регулярное предъявление подтверждений безопасности перехватывает их поиск и превращает подтверждающие доказательства из «это подозрительно» в «это законно».',
    category: 'Perception',
  },
  {
    id: 27,
    slug: 'post-purchase-rationalization',
    name: 'Послепокупная рационализация',
    scenario: 'Письмо-подтверждение заказа эргономичной клавиатуры за $149',
    withoutBias:
      'Сухое транзакционное письмо: «Заказ #4821 подтверждён. Ожидаемая доставка: 28 марта. Отследить заказ.»',
    withBias:
      'Брендированное письмо: «Отличный выбор! MechPro X — №1 по оценкам 12 000+ разработчиков. Ваш серийный номер: MP-2024-8841 (лимитированная серия). Вот гайд по настройке, чтобы выжать максимум из вашей новой клавиатуры.» с красивой фотографией продукта и цитатой клиента',
    whyItWorks:
      'Сразу после покупки покупатели наиболее уязвимы к сомнениям. Подкрепление качества решения социальным доказательством, сигналами эксклюзивности и конкретными следующими шагами даёт им аргументы, чтобы оправдать траты.',
    category: 'Memory',
  },
  {
    id: 28,
    slug: 'selective-perception',
    name: 'Избирательное восприятие',
    scenario: 'Раскладка панели инструментов редактора',
    withoutBias:
      'Нестандартная панель: жирный/курсив спрятаны в дропдауне «Ещё», цвет шрифта на основной панели, «Вставить таблицу» первой иконкой, выравнивание разбросано',
    withBias:
      'Стандартная панель по рыночному соглашению: жирный (B), курсив (I), подчёркнутый (U) как первые три иконки, затем выравнивание, списки, а продвинутые функции в дропдаунах',
    whyItWorks:
      'У пользователей сформированы ожидания от многолетнего использования Word/Google Docs. Нестандартное размещение создаёт ощущение, что стандартных функций нет, даже если они есть.',
    category: 'Perception',
  },
  {
    id: 30,
    slug: 'ostrich-effect',
    name: 'Эффект страуса',
    scenario: 'Финансовый дашборд',
    withoutBias:
      'Сырые негативные данные (использование кредита 78%, алерт о превышении бюджета)',
    withBias:
      'Эвфемистичные подписи («Всё по плану», «Возможность оптимизации», свёрнутые детали кредита)',
    whyItWorks:
      'Люди избегают дискомфортной информации. Маскировка тревожности мягкими формулировками сохраняет вовлечённость.',
    category: 'Social',
  },
  {
    id: 31,
    slug: 'subjective-validation',
    name: 'Субъективная валидация',
    scenario:
      'Форма регистрации в экологической НКО с заранее отмеченной галочкой',
    withoutBias:
      'Стандартная регистрация: имя, почта, пароль, кнопка «Создать аккаунт» — никакой работы с ценностями',
    withBias:
      'В регистрации — заранее отмеченная галочка: «Я хочу помогать защищать природу». После регистрации — сообщение «Добро пожаловать, защитник Земли!» Через две недели приходит просьба о пожертвовании со ссылкой на заявленную ценность',
    whyItWorks:
      'Галочка создаёт самоприписанное убеждение («я из тех, кому небезразлично»). Субъективная валидация заставляет пользователя воспринять позднейшую просьбу о пожертвовании как согласованную с тем, кто он есть.',
    category: 'Social',
  },
  {
    id: 32,
    slug: 'continued-influence-effect',
    name: 'Эффект продолжающегося влияния',
    scenario: 'Приложение здоровья обновляет рекомендацию по потреблению воды',
    withoutBias:
      'Приложение два года показывало «Пейте 8 стаканов воды в день». За ночь обновилось до «Пейте по жажде и уровню активности» без объяснений',
    withBias:
      'Экран обновления: «Что изменилось: правило «8 стаканов» было распространённым мнением, но свежие исследования показывают, что потребности индивидуальны. Вот почему мы обновили рекомендацию…» со сравнением «до/после» и ссылкой «Узнать больше»',
    whyItWorks:
      'Простое исправление старой информации не работает, потому что первоначальное утверждение остаётся в памяти. Явное признание того, во что пользователь верил, и объяснение перемен ослабляет продолжающееся влияние.',
    category: 'Memory',
  },
  {
    id: 34,
    slug: 'clustering-illusion',
    name: 'Иллюзия кластеризации',
    scenario: 'Расписание пушей приложения для благополучия',
    withoutBias:
      'Уведомления по фиксированному расписанию (9:00 каждый день): «Время ежедневной проверки!» — предсказуемо, легко игнорировать',
    withBias:
      'Уведомления со случайными интервалами (36–55 часов) и разными текстами: «Подходящий момент, чтобы сделать несколько осознанных вдохов», «Быстрая проверка: как вы сейчас себя чувствуете?» — без фиксированного графика',
    whyItWorks:
      'Пользователи воспринимают случайные уведомления как осмысленно подобранные («приложение всегда знает, когда мне это нужно!»), приписывая заботливый паттерн тому, что на самом деле является случайной частотой.',
    category: 'Memory',
  },
  {
    id: 35,
    slug: 'insensitivity-to-sample-size',
    name: 'Нечувствительность к размеру выборки',
    scenario: 'Страница сравнения продуктов с оценками пользователей',
    withoutBias:
      'Продукт A показан как «4,9 звёзд» (из 3 отзывов) рядом с продуктом B — «4,6 звёзд» (из 8 412 отзывов); оба оформлены одинаково',
    withBias:
      'Продукт A — «4,9 звёзд (3 отзыва) — данных недостаточно» приглушённо, продукт B — «4,6 звёзд (8 412 отзывов) — подтверждено» во всю мощь, с индикатором уверенности',
    whyItWorks:
      'Пользователи инстинктивно доверяют 4,9 больше, чем 4,6, не задумываясь, что 3 отзыва легко могут быть аномалией. Явное указание на размер выборки и уверенность компенсирует это искажение.',
    category: 'Social',
  },
  {
    id: 36,
    slug: 'neglect-of-probability',
    name: 'Пренебрежение вероятностью',
    scenario: 'Напоминание о резервной копии',
    withoutBias: '«Вероятность потери данных — около 0,01%»',
    withBias:
      '«Последняя резервная копия была 571 день назад» со статистикой сравнения с другими пользователями',
    whyItWorks:
      'Люди игнорируют вероятности и реагируют на эмоциональную тяжесть последствий. Уберите число — покажите последствия.',
    category: 'Decision',
  },
  {
    id: 37,
    slug: 'anecdotal-evidence',
    name: 'Анекдотические свидетельства',
    scenario: 'Раздел отзывов о продукте на лендинге',
    withoutBias:
      'Только агрегированные данные: «98% удовлетворённости по 12 000 клиентов» с гистограммой',
    withBias:
      'Одна подробная история: «Сара, фрилансер-дизайнер: «Я тонула в инвойсах, пока не нашла этот инструмент. Сэкономил 10 часов на прошлой неделе».» с фото и лого компании',
    whyItWorks:
      'Одна яркая личная история убеждает сильнее, чем агрегированная статистика. Люди откликаются на нарративы, а не на цифры.',
    category: 'Social',
  },
  {
    id: 39,
    slug: 'recency-illusion',
    name: 'Иллюзия новизны',
    scenario: 'Баннер анонса функции в SaaS-приложении',
    withoutBias:
      'Сайдбар показывает существующую функцию «Продвинутые фильтры» без особого оформления — она доступна уже 2 года',
    withBias:
      'Та же функция переупакована: «НОВОЕ: умные фильтры — на базе ИИ» с плашкой «Только что запущено», ссылкой на пост в блоге и подсвечивающей анимацией при первом заходе',
    whyItWorks:
      'Пользователи воспринимают недавно замеченные вещи как по-настоящему новые. Переупаковка существующих функций со свежим брендингом запускает открытие и принятие, даже если по сути ничего не изменилось.',
    category: 'Perception',
  },
  {
    id: 40,
    slug: 'gamblers-fallacy',
    name: 'Ошибка игрока',
    scenario: 'Экран лутбокса/таинственной награды в мобильной игре',
    withoutBias:
      '«Открыть таинственный ящик — $1,99» без дополнительного контекста',
    withBias:
      '«Вы открыли 7 ящиков без легендарного предмета. Игроки, открывшие 8+ ящиков, часто срывают куш!» с мерцающим прогресс-баром у золотого порога',
    whyItWorks:
      'Игроки верят, что выигрыш «задолжал» после серии проигрышей. Демонстрация длины полосы эксплуатирует ложное ощущение, что вероятность накапливается.',
    category: 'Decision',
  },
  {
    id: 41,
    slug: 'hot-hand-fallacy',
    name: 'Ошибка горячей руки',
    scenario:
      'Таблица лидеров соревновательной мультиплеерной игры во время серии побед',
    withoutBias:
      'Обычное отображение счёта: «Текущий ранг: #47. Побед сегодня: 8»',
    withBias:
      '«8 ПОБЕД ПОДРЯД! Вы в огне! Следующий матч — двойной XP-бонус для игроков со стриком.» с нарастающими с каждой победой анимациями пламени',
    whyItWorks:
      'Визуальные индикаторы прошлых успехов создают у игроков ощущение, что будущий успех вероятнее, несмотря на независимость исходов. Визуализация стрика поддерживает вовлечённость через ложный импульс.',
    category: 'Social',
  },
  {
    id: 42,
    slug: 'illusory-correlation',
    name: 'Иллюзорная корреляция',
    scenario: 'Маркетинговый лендинг SaaS с ассоциацией брендов',
    withoutBias:
      'Главная показывает функции продукта только с лого компании: «Управление проектами для современных команд»',
    withBias:
      '«Нам доверяют команды Google, Stripe и NASA» с этими логотипами рядом с лого продукта',
    whyItWorks:
      'Пользователи достраивают связь между продуктом и престижными брендами из простого сосуществования на странице — даже без реального партнёрства.',
    category: 'Perception',
  },
  {
    id: 43,
    slug: 'group-attribution-error',
    name: 'Ошибка групповой атрибуции',
    scenario: 'Флоу создания группы в соцсети',
    withoutBias: 'Форма «Создать группу» с полем имени и списком приглашений',
    withBias:
      'Форма «Создать группу» с обязательным полем «Миссия группы», слоганом общих ценностей и автогенерируемым бейджем идентичности («Новаторы — сильны 12 участниками»)',
    whyItWorks:
      'Заявленная групповая идентичность заставляет участников приписывать друг другу общие черты, укрепляя сплочённость и вовлечённость через воспринимаемый коллективный характер.',
    category: 'Social',
  },
  {
    id: 44,
    slug: 'fundamental-attribution-error',
    name: 'Фундаментальная ошибка атрибуции',
    scenario: 'Письмо клиентского успеха B2B SaaS',
    withoutBias:
      '«Ваша команда завершила 47 проектов за квартал с помощью ProjectFlow.»',
    withBias:
      '«Экспертиза вашей команды обеспечила 47 завершённых проектов за квартал. Ваше стратегическое планирование сделало разницу — вот ваш отчёт об успехе.»',
    whyItWorks:
      'Люди приписывают успех личным способностям, а не обстоятельствам. Признание заслуг пользователя (а не инструмента) усиливает лояльность и удовлетворённость.',
    category: 'Social',
  },
  {
    id: 46,
    slug: 'functional-fixedness',
    name: 'Функциональная фиксированность',
    scenario:
      'Меню панели инструментов веб-приложения с недоиспользуемыми инструментами',
    withoutBias:
      'Кнопка «Инструменты» открывает дропдаун из 4 пунктов. Аналитика показывает, что 97% кликов идут в «Экспорт» — остальные 3 инструмента пользователи не замечают',
    withBias:
      '«Экспорт» выведен отдельной кнопкой на панель. Остальные 3 инструмента переорганизованы в новый блок «Power Tools» с новыми иконками и вводными тултипами',
    whyItWorks:
      'Пользователи фиксируются на одной функции знакомого контрола. Разрыв пространственной ассоциации вынуждает переосмыслить и приводит к открытию упущенных функций.',
    category: 'Perception',
  },
  {
    id: 47,
    slug: 'just-world-fallacy',
    name: 'Ошибка справедливого мира',
    scenario: 'Страница объявления об изменении цен',
    withoutBias: '«С 1 марта цены вырастут на 15%. Новые цены ниже.»',
    withBias:
      '«Чтобы продолжать инвестировать в безопасность, доступность и честную оплату труда команды, мы корректируем цены на 15%. Вот куда именно идут ваши деньги:» и далее прозрачная разбивка расходов с бейджем «Обязательство справедливости»',
    whyItWorks:
      'Люди верят, что хорошие поступки заслуживают хороших исходов. Подача роста цен как справедливого, морального решения заставляет воспринимать его как заслуженное и честное.',
    category: 'Decision',
  },
  {
    id: 48,
    slug: 'authority-bias',
    name: 'Смещение авторитета',
    scenario: 'Экран медицинской рекомендации в приложении здоровья',
    withoutBias:
      '«Рекомендуется: 30 минут ходьбы ежедневно» — простой текстовый совет',
    withBias:
      '«Доктор Сара Чен, MD — Кардиология Johns Hopkins» с фото и регалиями, а затем та же рекомендация в виде цитаты с плашкой верификации',
    whyItWorks:
      'Люди подчиняются фигурам авторитета. Прикрепление экспертной личности и регалий к тому же совету резко увеличивает следование.',
    category: 'Social',
  },
  {
    id: 49,
    slug: 'automation-bias',
    name: 'Смещение автоматизации',
    scenario: 'Панель автоподсказок инструмента код-ревью',
    withoutBias:
      'Подсказка ИИ показана как: «Предложение: отрефакторить функцию», с тем же визуальным весом, что и ручные комментарии ревью',
    withBias:
      'Подсказка ИИ показана с заметной плашкой-щитом «Проверено ИИ», зелёной галочкой, индикатором уверенности «98,7% корректно», в выделенной карточке над ручными комментариями',
    whyItWorks:
      'Пользователи переоценивают автоматические системы с индикаторами уверенности. Визуальный авторитет плашки ИИ отбивает желание критически оценивать предложение.',
    category: 'Perception',
  },
  {
    id: 50,
    slug: 'bandwagon-effect',
    name: 'Эффект подражания',
    scenario: 'Карточка продукта с социальным доказательством',
    withoutBias: 'Базовая информация (имя, цена, рейтинг)',
    withBias: 'Добавлены «Тренд №1», сигналы покупок знакомых, 12 847 оценок',
    whyItWorks:
      'Индикаторы социального доказательства снижают воспринимаемый риск — если выбрали тысячи, значит, оно того стоит.',
    category: 'Social',
  },
  {
    id: 51,
    slug: 'placebo',
    name: 'Плацебо',
    scenario: 'Оптимизатор скорости интернета в личном кабинете провайдера',
    withoutBias:
      '«Мы в курсе периодических замедлений в вашем районе. Действий не требуется.»',
    withBias:
      'Кнопка «Запустить оптимизатор сети», запускающая анимированный прогресс-бар («Сканируем маршруты… Оптимизируем DNS… Очищаем кеш…») и завершающийся сообщением «Подключение оптимизировано! Скорость улучшена до 12%» — хотя реальных изменений не было',
    whyItWorks:
      'Даёт пользователю видимое действие, создающее ощущение улучшения. Ритуал «починки» удовлетворяет потребность в контроле и снижает количество жалоб.',
    category: 'Perception',
  },
  {
    id: 53,
    slug: 'in-group-favoritism',
    name: 'Внутригрупповой фаворитизм',
    scenario: 'Алгоритм ленты социальной сети',
    withoutBias:
      'Хронологическая лента показывает все посты одинаково — новости, мнения, мемы от всех контактов',
    withBias:
      'Лента приоритезирована по сигналам «своих»: посты пользователей с совпадающими бейджами профиля («Коллега-дизайнер»), общими группами и похожей историей взаимодействия подняты вверх с подписями «Из вашего сообщества»',
    whyItWorks:
      'Пользователи активнее вовлекаются в контент от воспринимаемых «своих». Поднятие сигналов племенной близости увеличивает время в ленте и частоту взаимодействий.',
    category: 'Social',
  },
  {
    id: 54,
    slug: 'halo-effect',
    name: 'Эффект ореола',
    scenario: 'Страница приложения в сторе',
    withoutBias:
      'Листинг с функциональными скриншотами, буллет-списком функций, рейтингом 4,2 звезды и простой иконкой',
    withBias:
      'Отполированный листинг с кинематографичным превью-видео, кастомной иллюстрацией героя, дизайнерской иконкой с градиентом, плашкой «Выбор редакции» и упоминанием Apple Design Award',
    whyItWorks:
      'Визуально поразительное первое впечатление заставляет пользователей считать, что качество продукта соответствует ему. Красивый дизайн «отсвечивает» на воспринимаемую надёжность и производительность.',
    category: 'Perception',
  },
  {
    id: 55,
    slug: 'positivity-effect',
    name: 'Эффект позитивности',
    scenario: 'Система реакций в инструменте командного сотрудничества',
    withoutBias:
      'Секция комментариев только с текстовыми ответами — без быстрых реакций',
    withBias:
      'Секция комментариев с кнопками позитивной реакции в один клик (хлопок, сердце, огонь, ракета, «Отличная идея!») на видном месте, а «Ответить» — сдержанной текстовой ссылкой',
    whyItWorks:
      'Пользователи охотно делятся позитивными эмоциями, когда для этого есть простой инструмент. Лёгкие позитивные реакции увеличивают вовлечённость и привязанность к платформе.',
    category: 'Social',
  },
  {
    id: 57,
    slug: 'mental-accounting',
    name: 'Ментальный учёт',
    scenario: 'Разбивка стоимости подписки',
    withoutBias: 'Одна строка «$29 в месяц»',
    withBias:
      'Разложено на четыре ценностные категории ($12 инструменты + $8 хранилище + $5 поддержка + $4 обучение)',
    whyItWorks:
      'Каждая подстатья оценивается по своему ментальному бюджету. Сумма ощущается более оправданной.',
    category: 'Decision',
  },
  {
    id: 58,
    slug: 'normality-bias',
    name: 'Смещение нормальности',
    scenario:
      'Приложение биржевой торговли с автоматическим подсказкой о стоп-лоссе',
    withoutBias:
      'Портфель показывает позиции с текущими ценами и процентами изменений — никаких алертов на необычные падения',
    withBias:
      'Когда акция падает на 15% за день, появляется заметный баннер: «Обнаружена необычная активность. Установить стоп-лосс?» с одноклик-опциями по порогу и переключателем «Авто-защита»',
    whyItWorks:
      'Пользователи предполагают, что всё идёт как обычно, и игнорируют предупреждения. Проактивные механизмы вмешательства переопределяют убеждение «само отскочит».',
    category: 'Decision',
  },
  {
    id: 61,
    slug: 'millers-law',
    name: 'Закон Миллера',
    scenario: 'Навигация панели настроек',
    withoutBias: 'Один список из 16 неструктурированных ссылок',
    withBias: 'Те же 16 пунктов, сгруппированные в 4 секции по 4 элемента',
    whyItWorks:
      'Рабочая память удерживает 7±2 элемента. Чанкование снижает когнитивную нагрузку.',
    category: 'Perception',
  },
  {
    id: 62,
    slug: 'illusion-of-transparency',
    name: 'Иллюзия прозрачности',
    scenario: 'Тултипы и подсказки в сложной форме конфигурации API',
    withoutBias:
      'Лаконичные подписи: «Webhook URL», «Auth Token», «Retry Policy» — без дополнительных объяснений',
    withBias:
      'Контекстные иконки помощи у каждого поля. При наведении всплывают тултипы простым языком: «Куда отправлять уведомления о событиях? Вставьте URL вашего сервера.» Плюс ссылка «Не уверены? См. гайд по настройке»',
    whyItWorks:
      'Создатели переоценивают очевидность своего интерфейса. Явные пояснения того, что кажется самоочевидным, резко снижают поток тикетов и замешательство пользователей.',
    category: 'Perception',
  },
  {
    id: 63,
    slug: 'curse-of-knowledge',
    name: 'Проклятие знания',
    scenario: 'Онбординг-прохождение инструмента для разработчиков',
    withoutBias:
      'Экран первого запуска: «Настройте CI/CD-пайплайн через YAML. Задайте триггеры сборки и цели деплоя.» — предполагает знание терминологии',
    withBias:
      'Пошаговый мастер с вопросом «Что вы хотите автоматизировать?» (простые опции: «Тестировать код», «Деплоить в продакшн», «И то и другое»), визуальный конструктор пайплайна, подписи без жаргона с раскрывающимися «Что это значит?»',
    whyItWorks:
      'Эксперты забывают, каково не знать. Замена жаргона ведомым выбором не даёт экспертизе команды превратиться в барьер для новых пользователей.',
    category: 'Social',
  },
  {
    id: 64,
    slug: 'spotlight-effect',
    name: 'Эффект прожектора',
    scenario: 'Подсказка при публикации контента',
    withoutBias: '«Все 5 000 участников увидят ваш пост»',
    withBias:
      '«Посты обычно получают 8–15 просмотров. Вы можете отредактировать или удалить в любой момент.»',
    whyItWorks:
      'Люди переоценивают внимание других. Реалистичные ожидания снижают социальную тревожность.',
    category: 'Social',
  },
  {
    id: 66,
    slug: 'hindsight-bias',
    name: 'Ретроспективное искажение',
    scenario: 'Страница постмортема инцидента в системе мониторинга',
    withoutBias:
      'После падения сервера: «Инцидент устранён. Причина: исчерпание пула соединений с БД.» Без дополнительного контекста',
    withBias:
      'Таймлайн со всеми пред-инцидентными сигналами и таймстемпами: «Эти 4 алерта возникли до падения. На тот момент ни один не превышал пороги предупреждения.» И блок «Что мы добавляем» с новыми предохранителями',
    whyItWorks:
      'После сбоя пользователи считают, что предупреждающие сигналы были очевидны. Демонстрация того, что пред-инцидентные данные в реальном времени были неоднозначными, предотвращает обвинение и создаёт доверие к проактивным улучшениям.',
    category: 'Memory',
  },
  {
    id: 70,
    slug: 'social-desirability-bias',
    name: 'Смещение социальной желательности',
    scenario: 'Встроенный опрос/форма обратной связи',
    withoutBias:
      '«Насколько вы довольны продуктом?» с рейтингом 1–5 звёзд — имя и аватар пользователя видны на форме',
    withBias:
      'Заметная плашка «Анонимная обратная связь», вопрос переформулирован как «Что ОДНО раздражает вас больше всего?» с заготовленными опциями и анонимным текстовым полем. Идентичность не показана',
    whyItWorks:
      'Люди дают социально одобряемые ответы, когда идентифицируемы. Анонимность плюс негативно сформулированные вопросы дают пользователям разрешение быть честными — и приносят действенные данные.',
    category: 'Social',
  },
  {
    id: 71,
    slug: 'third-person-effect',
    name: 'Эффект третьего лица',
    scenario: 'Маркетинговое письмо SaaS для опытных пользователей',
    withoutBias:
      'Агрессивное промо-письмо: «ПОТРЯСАЮЩАЯ скидка! Не упустите! Все переходят на нас!»',
    withBias:
      'Сдержанное письмо, основанное на данных: «Что изменилось в v4.2 и как это повлияет на ваш рабочий процесс» со статистикой использования и ненавязчивым CTA',
    whyItWorks:
      'Опытные пользователи считают себя устойчивыми к убеждению, поэтому открытый маркетинг вызывает скепсис. Сдержанный информационный тон обходит их защиты.',
    category: 'Social',
  },
  {
    id: 73,
    slug: 'hard-easy-effect',
    name: 'Эффект трудности-лёгкости',
    scenario: 'Многошаговая форма налогового калькулятора в финтех-приложении',
    withoutBias:
      'Одна плотная страница с 14 полями, выпадающими списками и условной логикой — всё видно сразу',
    withBias:
      'Тот же калькулятор разбит на 4 ведомых шага с прогресс-баром, контекстными подсказками и разумными значениями по умолчанию',
    whyItWorks:
      'Команды переоценивают, насколько их сложные интерфейсы просты для пользователей. Разложение сложности на мелкие шаги предотвращает ту путаницу, которую дизайнеры недооценивают.',
    category: 'Decision',
  },
  {
    id: 74,
    slug: 'dunning-kruger-effect',
    name: 'Эффект Даннинга — Крюгера',
    scenario: 'Подсказки по оптимизации рабочего процесса в CRM',
    withoutBias:
      'Пользователь вручную экспортирует контакты в CSV, редактирует в Excel, импортирует обратно — повторяет это каждый день без жалоб',
    withBias:
      'После обнаружения повторяющегося экспорта/импорта появляется контекстная подсказка: «Знали ли вы? Контакты можно редактировать массово прямо здесь. Посмотрите как (экономит ~20 мин в день)»',
    whyItWorks:
      'Пользователи с низкой осведомлённостью о возможностях не знают, что упускают. Проактивные подсказки открывают лучшие способы, которые сами они никогда бы не стали искать.',
    category: 'Perception',
  },
  {
    id: 75,
    slug: 'barnum-effect',
    name: 'Эффект Барнума',
    scenario: 'Уведомление с результатами теста',
    withoutBias:
      'Обезличенный результат (78/100, направления: коммуникация, тайм-менеджмент)',
    withBias:
      'Псевдо-персонализированные формулировки («вы цените эффективность», «другие полагаются на ваше суждение»)',
    whyItWorks:
      'Люди принимают расплывчатые лестные утверждения как уникально применимые к себе.',
    category: 'Memory',
  },
  {
    id: 76,
    slug: 'illusion-of-control',
    name: 'Иллюзия контроля',
    scenario: 'Голосование за будущие функции',
    withoutBias: 'Будущие функции в списке «Выпустим в Q3»',
    withBias:
      'Интерактивное голосование с текущими счётчиками голосов, баннером «Ваш голос важен!»',
    whyItWorks:
      'Чувство влияния создаёт ощущение владения. Проголосовавшие пользователи чувствуют связь с релизом.',
    category: 'Perception',
  },
  {
    id: 77,
    slug: 'illusory-superiority',
    name: 'Иллюзорное превосходство',
    scenario: 'Экран итогов тренировки в фитнес-приложении',
    withoutBias: '«Тренировка завершена. 32 минуты, 280 ккал.»',
    withBias:
      '«Вы разнесли её! Сегодня вы сожгли больше, чем 74% пользователей. Стрик топ-исполнителя: 3 дня подряд.» со сравнительным графиком',
    whyItWorks:
      'Люди переоценивают свои способности и охотно принимают подтверждение. Сравнительная лесть усиливает завышенный образ себя и повышает удержание.',
    category: 'Social',
  },
  {
    id: 78,
    slug: 'risk-compensation',
    name: 'Компенсация риска',
    scenario: 'Админ-панель облачной инфраструктуры с включённым авто-бэкапом',
    withoutBias:
      '«Авто-бэкап ВКЛ. Ваши данные полностью защищены.» (пользователь не читает предупреждения об изменениях, массово и беспечно удаляет записи)',
    withBias:
      '«Авто-бэкап ВКЛ. Проверьте: вы собираетесь удалить 1 204 записи. Восстановление из бэкапа занимает до 4 часов. Продолжить?»',
    whyItWorks:
      'Фичи безопасности делают пользователей беспечнее. Демонстрация реальных последствий ошибок противостоит ложному ощущению неуязвимости, которое дают автоматические защиты.',
    category: 'Decision',
  },
  {
    id: 79,
    slug: 'hyperbolic-discounting',
    name: 'Гиперболическое дисконтирование',
    scenario: 'Предложение перейти на годовую оплату',
    withoutBias: '«Экономьте 20% на годовом тарифе» (экономия $48 в год)',
    withBias: '«Получите первый месяц БЕСПЛАТНО» с таймером обратного отсчёта',
    whyItWorks:
      'Немедленные награды ценятся выше, чем более крупные отложенные. «Бесплатно сейчас» бьёт «сэкономить позже».',
    category: 'Decision',
  },
  {
    id: 80,
    slug: 'appeal-to-novelty',
    name: 'Апелляция к новизне',
    scenario: 'Баннер анонса фичи внутри SaaS-приложения',
    withoutBias: '«Построитель отчётов обновлён. Смотреть чейнджлог.»',
    withBias:
      '«НОВОЕ: построитель отчётов нового поколения — полностью переосмыслен и с ИИ-инсайтами. Попробуйте будущее отчётности.»',
    whyItWorks:
      'Люди приравнивают «новое» к «лучше». Акцент на новизне превращает то же улучшение в прорыв, который хочется попробовать прямо сейчас.',
    category: 'Perception',
  },
  {
    id: 81,
    slug: 'escalation-of-commitment',
    name: 'Эскалация обязательств',
    scenario:
      'Образовательная платформа показывает вложенное обучение на экране «думаю об отмене»',
    withoutBias:
      '«Отменить подписку на курс? Вы сможете вернуться в любое время.»',
    withBias:
      '«Вы вложили 14 часов и прошли 6 из 10 модулей. Вы на 60% пути. Продолжаем?» с визуализацией прогресса',
    whyItWorks:
      'Демонстрация накопленных инвестиций делает отказ «пустой тратой». Пользователи продолжают не потому, что курс ценен, а потому что бросить — значит «выбросить» вложенное.',
    category: 'Social',
  },
  {
    id: 82,
    slug: 'generation-effect',
    name: 'Эффект генерации',
    scenario: 'Повторение слов в приложении для изучения языков',
    withoutBias: 'Карточка показывает слово и перевод вместе: «Hund = Собака»',
    withBias:
      'Карточка показывает «H___» с контекстным предложением «Der ___ bellt laut», и пользователь должен напечатать ответ',
    whyItWorks:
      'Самостоятельно сгенерированные ответы оставляют более прочный след в памяти, чем пассивное чтение. Форсирование припоминания вместо узнавания резко улучшает удержание.',
    category: 'Memory',
  },
  {
    id: 83,
    slug: 'loss-aversion',
    name: 'Неприятие потерь',
    scenario: 'Окончание пробного периода',
    withoutBias: '«Перейдите на Pro за $15 в месяц» — перечисление выгод',
    withBias:
      '«Вы потеряете: 12,4 ГБ использованного хранилища, 6 сохранённых дашбордов, 3 месяца истории аналитики»',
    whyItWorks:
      'Боль от потери вдвое сильнее удовольствия от приобретения. Формулировка в логике потерь создаёт срочность.',
    category: 'Decision',
  },
  {
    id: 84,
    slug: 'ikea-effect',
    name: 'Эффект IKEA',
    scenario: 'Конструктор сайтов с кастомизацией шаблона',
    withoutBias:
      'Галерея готовых шаблонов: «Выберите шаблон. Мы всё настроим за вас.»',
    withBias:
      'Пошаговый конструктор: «Выберите цвета → Расставьте секции → Назовите сайт», а затем показывает «Ваше уникальное творение» с превью',
    whyItWorks:
      'Пользователи, вложившие усилия в создание, непропорционально ценят результат. Шаги кастомизации превращают обычный шаблон в «мой сайт».',
    category: 'Social',
  },
  {
    id: 85,
    slug: 'unit-bias',
    name: 'Смещение единицы',
    scenario: 'Пагинация списка задач',
    withoutBias: 'Один список из 36 ожидающих запросов',
    withBias: 'По 6 на странице с индикатором прогресса (0 из 36)',
    whyItWorks:
      'Завершаемые единицы поддерживают вовлечённость. 6 кажется достижимым, 36 — неподъёмным.',
    category: 'Memory',
  },
  {
    id: 86,
    slug: 'zero-risk-bias',
    name: 'Смещение нулевого риска',
    scenario: 'Оформление заказа с плашками гарантий',
    withoutBias: 'Стандартная политика возврата упомянута в секции оплаты',
    withBias:
      'Набор плашек исключения риска (30-дневная гарантия, бесплатный возврат, SSL, «100% без риска»)',
    whyItWorks:
      'Люди предпочитают полностью убрать маленький риск, чем сильнее сократить большой. Формулировка «нулевой риск» психологически мощная.',
    category: 'Decision',
  },
  {
    id: 87,
    slug: 'processing-difficulty-effect',
    name: 'Эффект сложности обработки',
    scenario: 'Подтверждение деструктивного действия',
    withoutBias: 'Обычное «Вы уверены?» с кнопкой «Да»',
    withBias:
      'Показывает воздействие (847 файлов, 23 коллаборатора) и требует напечатать «УДАЛИТЬ» для подтверждения',
    whyItWorks:
      'Когнитивное усилие оставляет более сильный след в памяти. Форсирует глубокое взаимодействие с последствиями.',
    category: 'Decision',
  },
  {
    id: 88,
    slug: 'endowment-effect',
    name: 'Эффект владения',
    scenario: 'Уведомление об обновлении раскладки дашборда',
    withoutBias:
      '«Новая раскладка применится через неделю, старая будет удалена»',
    withBias:
      'Учитывает кастомизации пользователя (4 виджета, 2 фильтра, кастомная тема), предлагает предпросмотр',
    whyItWorks:
      'Люди переоценивают то, чем владеют. Уважение владения ведёт к более высокому принятию изменений.',
    category: 'Memory',
  },
  {
    id: 89,
    slug: 'backfire-effect',
    name: 'Обратный эффект',
    scenario: 'Ответ поддержки на спор по биллингу',
    withoutBias:
      '«По нашим записям списание произведено корректно. Вот инвойс, подтверждающий списание. Раздел 4.2 Условий гласит…»',
    withBias:
      '«Понимаю, это списание было неожиданным. Давайте вместе разберём активность по вашему аккаунту — и если что-то не так, мы сразу исправим.»',
    whyItWorks:
      'Прямое возражение убеждению пользователя с доказательствами запускает защитное «упирание». Совместное исследование снимает сопротивление и открывает его корректной информации.',
    category: 'Memory',
  },
  {
    id: 90,
    slug: 'system-justification',
    name: 'Системное обоснование',
    scenario: 'Пост в корпоративном блоге во время общественно острого события',
    withoutBias:
      'Пост занимает чёткую публичную позицию по спорной социальной теме, призывая «присоединиться к движению»',
    withBias:
      'Пост держится продуктовых апдейтов и ценности для клиента, нейтральный и деловой язык',
    whyItWorks:
      'Пользователи защищают статус-кво как источник стабильности. Коммуникация бренда, бросающая вызов их мировоззрению, вызывает дискомфорт и отторжение, а не лояльность.',
    category: 'Social',
  },
  {
    id: 91,
    slug: 'reactance',
    name: 'Реактивное сопротивление',
    scenario: 'Апсейл-приглашение на апгрейд',
    withoutBias:
      'Принудительный попап «Вы ДОЛЖНЫ обновиться, чтобы продолжить»',
    withBias:
      'Ненавязчивый баннер с явным опт-аутом («Можно продолжить бесплатно, без давления»)',
    whyItWorks:
      'Ограничение свободы провоцирует сопротивление. Признание выбора повышает конверсию.',
    category: 'Social',
  },
  {
    id: 92,
    slug: 'decoy-effect',
    name: 'Эффект приманки',
    scenario: 'Таблица тарифов с асимметрично доминируемой опцией',
    withoutBias: 'Два плана (Basic $8, Premium $24)',
    withBias:
      'Добавлен план-приманка Plus ($22, функций меньше, чем у Premium)',
    whyItWorks:
      'Приманка делает Premium очевидно выгодной через асимметричную доминантность.',
    category: 'Decision',
  },
  {
    id: 93,
    slug: 'ambiguity-effect',
    name: 'Эффект неопределённости',
    scenario: 'Тарифы с расплывчатыми и конкретными функциями',
    withoutBias:
      'Расплывчатые фичи («Хранилище и поддержка», «больше функций»)',
    withBias:
      'Конкретные измеримые гарантии («50 ГБ хранилища», «99,9% аптайма»)',
    whyItWorks:
      'Люди избегают опций с неизвестной вероятностью. Квантифицированные выгоды убирают неопределённость.',
    category: 'Decision',
  },
  {
    id: 94,
    slug: 'information-bias',
    name: 'Информационное смещение',
    scenario: 'Инструмент сравнения товаров в e-commerce',
    withoutBias:
      'Страница продукта показывает 6 ключевых характеристик, цену и рейтинг — достаточно для решения. Кнопка «Купить» на видном месте',
    withBias:
      'Страница продукта добавляет «Сравнить с 12 похожими», раскрываемую таблицу из 40 характеристик, «Скачать полный datasheet (PDF)» и «Смотреть 200+ отзывов» — покупка теряется под слоями данных',
    whyItWorks:
      'Больше информации ощущается полезным, но тормозит решения. Пользователи, продолжающие сравнивать, редко конвертируют — достаточные данные работают лучше исчерпывающих.',
    category: 'Decision',
  },
  {
    id: 96,
    slug: 'conjunction-fallacy',
    name: 'Ошибка конъюнкции',
    scenario: 'Раздел «О команде» на сайте B2B SaaS',
    withoutBias:
      'Простой список: «Джон — CTO. Мария — ведущий инженер. Алекс — дизайнер.»',
    withBias:
      'Богатые био: «Джон — CTO, выпускник MIT CS, экс-Google, трижды основатель стартапа, публикующийся исследователь ИИ. Мария — ведущий инженер, сертификация AWS, строила системы на 10M+ запросов в день.»',
    whyItWorks:
      'Подробные связные нарративы кажутся достовернее редких фактов, хотя каждая добавленная деталь формально делает конъюнкцию менее вероятной. Пользователи приравнивают богатство истории к надёжности.',
    category: 'Social',
  },
  {
    id: 97,
    slug: 'less-is-better-effect',
    name: 'Эффект «меньше — значит лучше»',
    scenario: 'Уведомление о бонусе при апгрейде',
    withoutBias: '«10 бесплатных дней полного доступа ко всем функциям»',
    withBias: '«20 бесплатных кредитов InMail (стоимостью $40)»',
    whyItWorks:
      'Меньшее, но конкретное предложение ощущается ценнее, чем большое, но размытое. Важно соотношение качества к количеству.',
    category: 'Decision',
  },
  {
    id: 99,
    slug: 'prejudice',
    name: 'Предубеждение',
    scenario: 'Страница оформления заказа, локализованная для разных рынков',
    withoutBias:
      'Один и тот же дизайн глобально: белый фон, зелёная кнопка «Оплатить», номер заказа #1304',
    withBias:
      'Японская версия использует мягкие тёплые тона (белый не делают основным из-за ассоциаций с трауром), зелёный CTA сохраняется (позитивный в большинстве культур), номера заказов пропускают #4 и #13 (несчастливые в восточноазиатской и западной культурах)',
    whyItWorks:
      'Культурные предубеждения формируют неосознанные реакции на цвета, числа и символы. Локализация с учётом известных предубеждений предотвращает незапланированные негативные ассоциации, подавляющие конверсию.',
    category: 'Perception',
  },
  {
    id: 100,
    slug: 'fading-affect-bias',
    name: 'Эффект угасания аффекта',
    scenario: 'Страница статуса приложения после сбоя',
    withoutBias:
      'Инцидент бессрочно закреплён сверху страницы статуса с красным баннером «Серьёзный сбой»',
    withBias:
      'После разрешения инцидент уезжает в историю за 48 часов. Страница статуса открывается «Все системы работают штатно» на зелёном фоне. Секция улучшений подсвечивает 3 новые фичи надёжности, выпущенные после инцидента',
    whyItWorks:
      'Негативные эмоции от плохого опыта гаснут быстрее, чем позитивные. Быстрая замена нарратива сбоя на операционную уверенность ускоряет естественное угасание негативного аффекта.',
    category: 'Memory',
  },
  {
    id: 101,
    slug: 'peak-end-rule',
    name: 'Правило пика и конца',
    scenario: 'Страница подтверждения заказа',
    withoutBias: '«Заказ оформлен. Вы получите письмо.»',
    withBias:
      'Оценка доставки, личная записка, промокод на 10% и плашки доверия',
    whyItWorks:
      'Память непропорционально взвешивает пик и концовку. Вознаграждение финального шага улучшает воспоминание обо всём опыте.',
    category: 'Memory',
  },
  {
    id: 102,
    slug: 'serial-recall',
    name: 'Серийное припоминание',
    scenario: 'Многошаговый мастер онбординга инструмента управления проектами',
    withoutBias:
      'Шаги в произвольном порядке: «Пригласить команду → Установить свою роль → Назвать проект → Подключить интеграции»',
    withBias:
      'Шаги в естественной причинно-следственной последовательности: «Назвать проект → Установить свою роль → Пригласить команду → Подключить интеграции» с нумерованным прогресс-баром',
    whyItWorks:
      'Люди лучше запоминают последовательности, когда порядок соответствует причинно-следственной логике. Связный порядок шагов снижает когнитивное трение и помогает повторить рабочий процесс.',
    category: 'Memory',
  },
  {
    id: 103,
    slug: 'list-length-effect',
    name: 'Эффект длины списка',
    scenario: 'Тарифы с количеством функций',
    withoutBias: 'Пять планов с 8–12 функциями в каждом',
    withBias:
      'Три плана с 3–5 ключевыми функциями каждый, ссылка «Сравнить все функции»',
    whyItWorks:
      'С ростом длины списка запоминание падает. Меньше опций и меньше пунктов — выше конверсия.',
    category: 'Decision',
  },
  {
    id: 104,
    slug: 'primacy-effect',
    name: 'Эффект первенства',
    scenario: 'Приветственный экран онбординга',
    withoutBias: 'Обобщённое «Добро пожаловать в TaskFlow» со списком функций',
    withBias:
      'Персонализированное «Добро пожаловать, Сара. Вы начнёте экономить по 5 часов каждую неделю.»',
    whyItWorks:
      'Первое впечатление якорит всё восприятие. Онбординг заслуживает непропорционально большого внимания дизайнера.',
    category: 'Memory',
  },
  {
    id: 105,
    slug: 'serial-position-effect',
    name: 'Эффект последовательной позиции',
    scenario: 'Порядок пунктов в релиз-нотах',
    withoutBias:
      'Нейтральный порядок (сначала багфиксы, фичи вперемежку, повышение цен видно)',
    withBias: 'Лучшие новости в начале и в конце, повышение цен в середине',
    whyItWorks:
      'Первые и последние элементы запоминаются лучше всего. Плохие новости прячьте в середине.',
    category: 'Memory',
  },
  {
    id: 26,
    slug: 'congruence-bias',
    name: 'Искажение конгруэнтности',
    scenario: 'Постановка A/B-теста для гипотезы про цвет CTA',
    withoutBias:
      'Только два варианта — текущий серый и предполагаемый победитель зелёный. B выигрывает на 3%; команда релизит, считая гипотезу подтверждённой.',
    withBias:
      'Четыре варианта, включая «должен проиграть» красный и контрольный без CTA. Неожиданно выигрывает красный — настоящим драйвером оказалось расположение, а не цвет.',
    whyItWorks:
      'Тест, спроектированный только на подтверждение, не может опровергнуть. Добавление вариантов, которые должны проиграть по вашей гипотезе, показывает, поняли вы систему или просто угадали.',
    category: 'Decision',
  },
  {
    id: 29,
    slug: 'observer-expectancy-effect',
    name: 'Эффект ожиданий наблюдателя',
    scenario: 'Скрипт интервью по новому дашборду',
    withoutBias:
      'Наводящие формулировки: «Согласитесь, новый дашборд намного быстрее?» Все соглашаются; команда уверенно релизит; отток подскакивает.',
    withBias:
      'Открытые формулировки: «Расскажите, что вы делали». 4 из 6 спотыкаются на флоу, о котором никто раньше не говорил, потому что прошлые вопросы об этом не спрашивали.',
    whyItWorks:
      'Закрытые и наводящие вопросы дают участнику ответ. Открытые, привязанные к поведению, показывают, что люди реально делают, а не то, с чем они вежливо согласятся.',
    category: 'Perception',
  },
  {
    id: 33,
    slug: 'bias-blind-spot',
    name: 'Слепое пятно искажений',
    scenario: 'Панель собеседований по senior-кандидату',
    withoutBias:
      'Свободный фидбек: «Сильное первое впечатление. Напоминает Джордана с платформы — там сложилось». Оценка 4.5/5 без привязанных доказательств.',
    withBias:
      'Структурированный рубрик: каждый критерий — оценка, доказательство с лупа, обязательный промпт «назовите одну конкретную причину, почему этот кандидат может не справиться».',
    whyItWorks:
      'Свою предвзятость нельзя осознать. Требование доказательств по каждому критерию и явный промпт на контр-аргумент убирают пространство, где прячется bias — расплывчатые впечатления.',
    category: 'Decision',
  },
  {
    id: 38,
    slug: 'illusion-of-validity',
    name: 'Иллюзия достоверности',
    scenario: 'Квартальный прогноз для руководства',
    withoutBias:
      '«87% активации, высокая уверенность» — одна жирная цифра. Размер выборки n=12 спрятан.',
    withBias:
      '«Реалистичный диапазон 34–91%, n=12» с явным интервалом и предупреждением: не фиксировать роадмап до n=200.',
    whyItWorks:
      'Одна цифра из крошечной выборки выглядит решающей, но прячет огромную неопределённость. Принудительный диапазон обнажает разброс и предотвращает преждевременные коммитменты.',
    category: 'Decision',
  },
  {
    id: 45,
    slug: 'stereotype',
    name: 'Стереотип',
    scenario: 'Персонализированный дашборд для пользователей SaaS',
    withoutBias:
      'Один и тот же «Engineering Manager»-дашборд на всех 240 менеджеров — роль приравнивается к потребностям.',
    withBias:
      'Дашборд по живым сигналам: PR-ы, открытые виджеты, игнорируемые модули. Майя получает on-call + очередь PR, а не планирование штата, которое она не открывает.',
    whyItWorks:
      'Роль показывает категорию; поведение показывает человека. Реальная активность каждый раз бьёт демографическую догадку — пользователь сам это подтверждает каждым открытием приложения.',
    category: 'Social',
  },
  {
    id: 52,
    slug: 'out-group-homogeneity',
    name: 'Гомогенность чужой группы',
    scenario: 'Реактивация free-tier пользователей письмом',
    withoutBias:
      'Один блок на 48 000 free-пользователей: «Перейдите на Pro и получите всё без ограничений!» Конверсия: 0,4%.',
    withBias:
      'Три поведенческих сегмента — активные, упирающиеся в лимиты; эпизодические для Lite-плана; застрявшие в старте, которым предлагают гайд по настройке. Конверсия: 3,1%.',
    whyItWorks:
      'Free-пользователи — не одна аудитория, а три, делящие тариф. Сегментация по поведению позволяет сообщению попадать в реальную потребность.',
    category: 'Social',
  },
  {
    id: 56,
    slug: 'not-invented-here',
    name: 'Синдром «придумано не здесь»',
    scenario: 'Решение про аутентификацию в B2B-продукте',
    withoutBias:
      '6-месячная разработка собственного OAuth, $420K и 2 выделенных инженера. Роадмап заморожен. Ноль клиентских фич.',
    withBias:
      'Подключаем проверенного провайдера, связываем за 2 недели, $18K/год. Инженеры освобождены под реальный дифференциатор.',
    whyItWorks:
      'Гордость «строить всё самим» закрывает глаза на цену. Покупать commodity-слой и строить только то, что отличает вас, — почти всегда правильное соотношение.',
    category: 'Social',
  },
  {
    id: 59,
    slug: 'survival-bias',
    name: 'Ошибка выжившего',
    scenario: 'Маркетинговые кейсы на сайте продукта',
    withoutBias:
      'Три глянцевых победы («+340% MRR», «×5 удержание») и баннер «присоединяйтесь к 1 200 успешным командам». Провалы невидимы.',
    withBias:
      'Честное распределение: 12% больших побед, 51% умеренного роста, 24% без изменений, 13% ушедших — с разделом, кто обычно проваливается и как заметить заранее.',
    whyItWorks:
      'Выжившие показывают только то, что работает для выживших. Показывая ушедших, вы строите доверие и помогаете правильным клиентам отсеять себя самим, не оттекая позже.',
    category: 'Decision',
  },
  {
    id: 60,
    slug: 'subadditivity-effect',
    name: 'Эффект субаддитивности',
    scenario: 'Карточка тарифа «всё включено»',
    withoutBias:
      '«$99/мес — все возможности платформы». Одна цифра, без разбивки.',
    withBias:
      'Те же $99 разбиты: Хранилище $30 + Поддержка $25 + Аналитика $30 + Интеграции $24 + Audit $18, и «Экономия $28/мес по сравнению с отдельной покупкой».',
    whyItWorks:
      'Сумма сравнивается с одним числом; раскладка — с пятью. Декомпозиция увеличивает воспринимаемую ценность, потому что мозг складывает компоненты, а не суммирует общую цифру.',
    category: 'Decision',
  },
  {
    id: 65,
    slug: 'illusion-of-asymmetric-insight',
    name: 'Иллюзия асимметричной проницательности',
    scenario: 'Пост в Slack с продуктовым решением',
    withoutBias:
      '«Думаю, все согласны, что новый флоу — очевидный win. Релизим в пятницу». Тишина истолкована как согласие.',
    withBias:
      'Шаблон решения: что предлагаю, почему, что могу упускать, как пойму, что ошибся — и просьба «ответьте одним пунктом, который вы прочитали иначе».',
    whyItWorks:
      'Тишина — не согласие, а неоднозначность. Структурированное раскрытие и явный запрос на несогласие обнажает разрыв между тем, что вы отправили, и тем, что услышали.',
    category: 'Social',
  },
  {
    id: 67,
    slug: 'planning-fallacy',
    name: 'Ошибка планирования',
    scenario: 'Инженерная оценка миграции биллинга',
    withoutBias:
      'Одна цифра: «3 дня». Релиз с опозданием на 18 дней; на второй неделе клиентов списали дважды.',
    withBias:
      'Трёхточечная оценка (3д / 7д / 14д), привязанная к исторической пропорции: предыдущие 3 похожих проекта в среднем шли 2,5× от изначальной оценки.',
    whyItWorks:
      'В одиночных оценках доминирует оптимизм. Трёхточечные диапазоны плюс исторические факты заставляют команду честно посмотреть, как держались её прошлые оценки.',
    category: 'Decision',
  },
  {
    id: 68,
    slug: 'pro-innovation-bias',
    name: 'Про-инновационное искажение',
    scenario: 'Раскатка Editor 2.0 в долгоживущем продукте',
    withoutBias:
      '«Старый редактор уходит — переходите сейчас!» с одной большой кнопкой. Топ саппорт-тикет: воркфлоу сломан перед запуском.',
    withBias:
      '«Новый редактор доступен — Classic поддерживается до 2027». Две кнопки (попробовать бету / остаться на Classic) и явное обещание поддержки.',
    whyItWorks:
      'Принудительная миграция считает наработанные воркфлоу пользователей расходным материалом. Сосуществование уважает то, что уже работает, и зарабатывает апгрейд, когда он реально экономит время.',
    category: 'Decision',
  },
  {
    id: 69,
    slug: 'overconfidence-effect',
    name: 'Эффект самоуверенности',
    scenario: 'Квартальный прогноз активных пользователей',
    withoutBias:
      'Точечная оценка (420 000) с самооценкой уверенности 95%. Исторический хитрейт на этом уровне: 41%.',
    withBias:
      'Принудительный 90%-ный диапазон (290 000–610 000) с правилами калибровки и привычкой трекать прогноз vs факт, чтобы будущие диапазоны становились честнее.',
    whyItWorks:
      'Самооценке уверенности доверять нельзя; 90%-ный диапазон сложно подделать — он заставляет признать, насколько широка может быть реальность. Со временем калибровка делает диапазоны точнее.',
    category: 'Decision',
  },
  {
    id: 72,
    slug: 'consensus-bias',
    name: 'Эффект ложного консенсуса',
    scenario: 'Выбор онбординг-флоу по внутреннему голосованию',
    withoutBias:
      'Опрос команды: 71% за «быстрый тур». Решение: релизим тур — пользователям тоже зайдёт.',
    withBias:
      'Опрос команды плюс опрос клиентов (n=412): только 12% клиентов выбирают тур; 65% хотят demo-видео.',
    whyItWorks:
      'Комната согласия — не комната покупки. Сопоставление внутренних предпочтений с реальным сигналом от клиентов обнажает разрыв до того, как он станет провалом запуска.',
    category: 'Social',
  },
  {
    id: 95,
    slug: 'law-of-triviality',
    name: 'Закон тривиальности',
    scenario: 'Повестка планирования спринта',
    withoutBias:
      '52 минуты на «teal vs navy CTA», потому что у всех есть мнение. 8 минут на миграцию БД, которая может уронить чекаут.',
    withBias:
      'Повестка с тайм-боксами: 45м на план миграции, 25м на error-budget политику, по 5м на bikeshed-темы с правилом «по умолчанию решает один владелец».',
    whyItWorks:
      'Тривиальные решения приглашают участие — мнение может быть у каждого; важные отталкивают. Тайм-боксинг по влиянию выравнивает внимание со ставками.',
    category: 'Social',
  },
  {
    id: 98,
    slug: 'implicit-stereotypes',
    name: 'Имплицитные стереотипы',
    scenario: 'Первичный скрининг take-home задания на инженерную позицию',
    withoutBias:
      'Ревьюер видит имя, фото, вуз. Callback при равных навыках для кандидатов из недопредставленных групп: 11%.',
    withBias:
      'Слепой ревью: имя, фото и вуз скрыты до этапа интервью. Callback при равных навыках: 34%.',
    whyItWorks:
      'Имплицитные ассоциации срабатывают быстрее осознанного суждения. Убрать триггер в момент оценки — значит дать работе говорить за работу. И данные сразу показывают, как разрыв закрывается.',
    category: 'Social',
  },
];
